import React, { useContext, useEffect, useState } from "react";
import $ from "jquery";
import axios, { all } from "axios";
import { BASE_URL } from "../../utils/Constants";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import "./Leads.css";
import AuthContext from "../../store/auth-context";
const Leads = () => {
  const [allLeads, setAllLeads] = useState([]);
  let navigate = useNavigate();
  const [campaigns, setCampaigns] = useState([]);
  const [campaign_id, setCampaign_id] = useState(0);
  const AuthCtx = useContext(AuthContext);

  useEffect(() => {
    // Fetch leads whenever campaign_id changes
    Swal.showLoading();

    // Destroy existing DataTable before fetching new data
    if ($.fn.dataTable.isDataTable("#dataTable")) {
      $("#dataTable").DataTable().destroy();
    }

    axios
      .get(
        `${BASE_URL}/marktingfunctions/getleads.php?campaign_id=${campaign_id}`,
      )
      .then((res: any) => {
        setAllLeads(res.data.data);
        Swal.close();
      })
      .catch((err: any) => {
        AuthCtx.Logout();
      });
  }, [campaign_id, AuthCtx]);

  useEffect(() => {
    // Re-initialize DataTable after allLeads state is updated and DOM is rendered
    if (allLeads.length > 0) {
      // Small delay to ensure React has finished rendering the rows
      const timer = setTimeout(() => {
        if (!$.fn.dataTable.isDataTable("#dataTable")) {
          $("#dataTable").DataTable({
            order: [[5, "desc"]],
            pageLength: -1,
            lengthMenu: [
              [-1, 10, 25, 50],
              ["All", 10, 25, 50],
            ],
          });
        }
      }, 100);

      return () => clearTimeout(timer);
    }
  }, [allLeads]);

  useEffect(() => {
    axios
      .get(`${BASE_URL}/marktingfunctions/getutils.php`)
      .then((res: any) => {
        setCampaigns(res.data.data);
      })
      .catch((err: any) => {});
  }, []);

  const handleLead = (id = 0) => {
    navigate(`/leadContent?id=${id}`);
  };

  const covertLeadToUser = (lead_id: any) => {
    axios
      .post(
        `${BASE_URL}/marktingfunctions/covertleadtouser.php?lead_id=${lead_id}&campaign_id=${campaign_id}`,
      )
      .then((res) => {
        Swal.fire({
          title: "Success",
          text: "Lead converted to user successfully and email and password copied to clipboard",
          icon: "success",
          confirmButtonText: "Copy",
        }).then(() => {
          navigator.clipboard.writeText(
            `Email: ${res.data.data.email}\nPassword: ${res.data.data.password}`,
          );
          let tempLeads: any = [...allLeads];
          let index = tempLeads.findIndex((lead: any) => lead.id === lead_id);
          tempLeads[index].isconverted = 1;
          setAllLeads(tempLeads);
        });
      })
      .catch((err) => {
        Swal.fire("Error", err.response.data.msg, "error");
      });
  };
  const handleAddFollowUp = (lead_id: any) => {
    Swal.fire({
      title: "Add Follow Up",
      html: `
        <div class="mb-3 text-start">
          <label class="form-label">Way of Contact</label>
          <select id="contact_method" class="form-select" required >
            <option value="">Select</option>
            <option value="Call">Call</option>
            <option value="WhatsApp">WhatsApp</option>
            <option value="Facebook">Facebook</option>
          </select>
        </div>
        <div class="mb-3 text-start">
          <label class="form-label">Notes</label>
          <textarea id="notes" class="form-control" rows="3" placeholder="Enter notes here..."></textarea>
        </div>
        <div class="mb-3 text-start">
          <label class="form-label">Contact Back (Optional)</label>
          <input type="datetime-local" id="contact_back" class="form-control">
        </div>
      `,
      focusConfirm: false,
      preConfirm: () => {
        const contact_method = (
          document.getElementById("contact_method") as HTMLSelectElement
        ).value;
        const notes = (document.getElementById("notes") as HTMLTextAreaElement)
          .value;
        const contact_back = (
          document.getElementById("contact_back") as HTMLInputElement
        ).value;
        if (!contact_method) {
          Swal.showValidationMessage("Please select way of contact");
          return false;
        }
        if (!notes) {
          Swal.showValidationMessage("Please enter notes");
          return false;
        }
        return {
          contact_method,
          notes,
          contact_back: contact_back || null,
        };
      },
      showCancelButton: true,
      confirmButtonText: "Save",
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .post(`${BASE_URL}/marktingfunctions/savefollowup.php`, {
            lead_id: lead_id,
            ...result.value,
          })
          .then((res) => {
            Swal.fire("Success", "Follow up saved successfully", "success");
            // Refresh leads list to show the new follow-up
            setAllLeads((prevLeads: any) => {
              return prevLeads.map((lead: any) => {
                if (lead.id === lead_id) {
                  const newFollowup = {
                    ...res.data.data,
                    creator_name: AuthCtx.displayname,
                  };
                  return {
                    ...lead,
                    followups: [newFollowup, ...(lead.followups || [])],
                  };
                }
                return lead;
              });
            });
          })
          .catch((err) => {
            Swal.fire("Error", "Failed to save follow up", "error");
          });
      }
    });
  };

  const markLeadAsWrong = (lead_id: any) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This will mark the lead as wrong and highlight it in red.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, mark it!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .post(`${BASE_URL}/marktingfunctions/markwronglead.php`, { lead_id })
          .then((res) => {
            Swal.fire("Success", "Lead marked as wrong", "success");
            setAllLeads((prevLeads: any) => {
              return prevLeads.map((lead: any) => {
                if (lead.id === lead_id) {
                  return { ...lead, is_wrong: 1 };
                }
                return lead;
              });
            });
          })
          .catch((err) => {
            Swal.fire("Error", "Failed to mark lead", "error");
          });
      }
    });
  };

  return (
    <>
      <button
        className="btn mb-3"
        style={{ backgroundColor: "#51469c", color: "white" }}
        onClick={() => {
          handleLead();
        }}
      >
        {" "}
        Add lead{" "}
      </button>
      <select
        name=""
        id=""
        className="form-select mb-3"
        onChange={(e: any) => {
          setCampaign_id(e.target.value);
        }}
      >
        <option value="0">Select campaign</option>
        {campaigns?.map((campaign: any) => {
          return (
            <option key={campaign.id} value={campaign.id}>
              {campaign.name}
            </option>
          );
        })}
      </select>
      <div className="table-responsive">
        <table id="dataTable" className="table table-bordered">
          <thead>
            <tr>
              <th scope="col">id</th>
              <th
                scope="col"
                style={{
                  fontSize: "12px",
                  color: "black",
                  backgroundColor: "#eeeeee",
                  textAlign: "center",
                  position: "sticky",
                  left: 0,
                  border: "1px solid black",
                  zIndex: 50,
                }}
              >
                Lead Name
              </th>
              <th
                scope="col"
                style={{
                  width: "50px",
                  minWidth: "50px",
                  maxWidth: "50px",
                }}
              >
                Email
              </th>
              <th scope="col">Mobile </th>
              <th scope="col" style={{ minWidth: "250px" }}>
                Follow ups
              </th>
              <th scope="col" style={{ minWidth: "250px" }}>
                Registered date
              </th>
              <th scope="col">Converted By</th>
              <th scope="col">Actions</th>
            </tr>
          </thead>
          <tbody>
            {allLeads?.map((lead: any, index: number) => {
              const isToday = lead.followups?.some((f: any) => {
                if (!f.contact_back) return false;
                const contactDate = new Date(f.contact_back).toDateString();
                const today = new Date().toDateString();
                return contactDate === today;
              });

              return (
                <tr
                  key={lead.id}
                  style={
                    lead.is_wrong == 1
                      ? { backgroundColor: "red", color: "white" }
                      : isToday
                        ? { backgroundColor: "green", color: "white" }
                        : {}
                  }
                >
                  <th scope="row">{index + 1}</th>
                  <td
                    style={{
                      fontSize: "12px",
                      color: "black",
                      backgroundColor: "#eeeeee",
                      textAlign: "center",
                      position: "sticky",
                      left: 0,
                      border: "1px solid black",
                      zIndex: 50,
                    }}
                  >
                    {lead.name}
                  </td>
                  <td
                    style={{
                      width: "50px",
                      minWidth: "50px",
                      maxWidth: "50px",
                      wordBreak: "break-all",
                    }}
                  >
                    {lead.email}
                  </td>
                  <td>{lead.mobile}</td>
                  <td>
                    <div style={{ maxHeight: "150px", overflowY: "auto" }}>
                      {lead.followups?.map((f: any) => (
                        <div
                          key={f.id}
                          className="p-2 mb-2 bg-light rounded shadow-sm border-start border-4 border-primary"
                          style={{ fontSize: "12px" }}
                        >
                          <div className="d-flex justify-content-between align-items-center mb-1">
                            {f.contact_method === "WhatsApp" ? (
                              <i
                                className="bi bi-whatsapp text-success fs-6"
                                title="WhatsApp"
                              ></i>
                            ) : (
                              <i
                                className="bi bi-telephone-fill text-info fs-6"
                                title="Call"
                              ></i>
                            )}
                            <small
                              className="text-bold"
                              style={{ fontSize: "12px", color: "black" }}
                            >
                              {new Date(f.created_at).toLocaleString()}
                            </small>
                          </div>
                          <div
                            className="text-dark mb-1"
                            style={{ fontSize: "16px", fontWeight: "bold" }}
                          >
                            {f.notes}
                          </div>
                          {f.contact_back && (
                            <div
                              className="mb-1 text-danger"
                              style={{ fontSize: "12px", fontWeight: "bold" }}
                            >
                              <i className="bi bi-calendar-event me-1"></i>
                              Contact Back:{" "}
                              {new Date(f.contact_back).toLocaleString()}
                            </div>
                          )}
                          <div
                            className="text-end text-bold"
                            style={{
                              fontSize: "12px",
                              fontStyle: "italic",
                              color: "black",
                            }}
                          >
                            By {f.creator_name}
                          </div>
                        </div>
                      ))}
                    </div>
                    <button
                      onClick={() => handleAddFollowUp(lead.id)}
                      className="btn btn-sm "
                      style={{ backgroundColor: "#51469c", color: "white" }}
                    >
                      + Follow Up
                    </button>
                  </td>
                  <td>{lead?.created_at}</td>
                  <td>
                    {lead?.isconverted == 1 ? lead?.converted_by_name : ""}
                  </td>
                  <td>
                    {lead?.is_wrong == 1 || lead?.isconverted == 1 ? (
                      <>
                        {lead.isconverted == 1 ? (
                          <>
                            <i
                              className="bi bi-check-circle-fill text-success fs-4"
                              title="This lead was converted to user"
                            ></i>
                            Subscribed
                          </>
                        ) : (
                          ""
                        )}
                      </>
                    ) : (
                      <>
                        <button
                          onClick={() => {
                            handleLead(lead.id);
                          }}
                          className="btn "
                          style={{ backgroundColor: "#63c29d" }}
                        >
                          Edit{" "}
                        </button>
                        <button
                          onClick={() => {
                            covertLeadToUser(lead.id);
                          }}
                          className="btn "
                          style={{ backgroundColor: "blue" }}
                        >
                          Convert To User{" "}
                        </button>
                        <button
                          onClick={() => {
                            markLeadAsWrong(lead.id);
                          }}
                          className="btn btn-danger"
                        >
                          Mark Wrong{" "}
                        </button>
                      </>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default Leads;
